import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const Main = styled.div`
  width: 100%;
  height: 100%;
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0px;
  table-layout: fixed;
`;
export const Thead = styled.thead`
  background-color: ${ColorSF2.white};
`;
export const TheadTr = styled.tr`
  border-top: 1px solid ${ColorSF2.mediumGray};
  text-decoration: none;
  height: 27px;
  font-size: 12px;
  display: flex;
  align-items: center;
`;
export const ThFavoriteName = styled.th`
  overflow: hidden;
  padding-left: 10px;
  tex-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
`;
export const Tbody = styled.tbody`
  width: 100%;
  background-color: ${ColorSF2.white};
`;
export const TbodyTr = styled.tr`
  width: 100%;
  height: 48px;
  padding: 8px;
  border-top: 1px solid ${ColorSF2.mediumGray};
  background-color: ${ColorSF2.white};
  text-decoration: none;
  display: flex;
  flex-direction: row;

  &:last-child {
    border-bottom: 1px solid ${ColorSF2.mediumGray};
  }
`;

export const TdFavoriteName = styled.td`
  width: calc(100% - 40px);
  padding: 0px;
  padding-left: 6px;
  display: flex;
  flex: 1;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
`;
export const ScrolledBody = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
`;
export const SortWrapper = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
`;
export const FavoriteNameWrapper = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: start;
  align-items: center;
`;
export const FavoriteName = styled.div`
  width: 140px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
export const FavoriteMember = styled.div`
  margin-left: 10px;
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`;
export const ButtonImage = styled.img`
  margin-right: 4px;
  margin-bottom: 1px;
  height: 14px;
  display: flex;
  align-items: center;
`;
